import { loading, handleErrorException, success } from 'State/actions';
import * as types from './types';

export const updateLunchGridData = data => {
  return {
    type: types.BASE_RATES_UPDATE_LUNCH_GRID_DATA,
    payload: data,
  };
};
export const updateBreakfastGridData = data => {
  return {
    type: types.BASE_RATES_UPDATE_BREAKFAST_GRID_DATA,
    payload: data,
  };
};

export const setToggle = isToggled => {
  return { type: types.BASE_RATES_UPDATE_SET_TOGGLE, payload: isToggled };
};

export const writeBaseRatesChanges = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BASE_RATES_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        'Provision2/UpdateBaseRates',
        data
      );
      dispatch(setSaveSuccessful(true));
    } catch (error) {
      const writeError = {
        Title: 'Error',
        Message:
          'An error occured while attempting to write the changes. Please try again.',
      };
      dispatch(handleErrorException(error, types.BASE_RATES_ERROR, writeError));
    }
    dispatch(loading(types.BASE_RATES_LOADING, false));
  };
};

export const setSaveSuccessful = value => {
  return {
    type: types.BASE_RATES_SET_SUCCESSFUL,
    payload: value,
  };
};

export const updateSite = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BASE_RATES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(`Provision2/${siteId}`);
      dispatch(
        success(types.BASE_RATES_UPDATE_SITE, {
          response: response.data.Data,
          siteId,
        })
      );
    } catch (error) {
      const getDataError = {
        Title: 'Error',
        Message: 'An error occured while getting the data. Please try again.',
      };

      dispatch(
        handleErrorException(error, types.BASE_RATES_ERROR, getDataError)
      );
    }
    dispatch(loading(types.BASE_RATES_LOADING, false));
  };
};

export const updateFiscalYear = fiscalYear => {
  return {
    type: types.BASE_RATES_UPDATE_FISCAL_YEAR,
    payload: fiscalYear,
  };
};

export const updateOtherFiscalYear = fiscalYear => {
  return {
    type: types.BASE_RATES_UPDATE_OTHER_FISCAL_YEAR,
    payload: fiscalYear,
  };
};

export const updateOtherFiscalYears = otherFiscalYears => {
  return {
    type: types.BASE_RATES_UPDATE_OTHER_FISCAL_YEARS,
    payload: otherFiscalYears,
  };
};



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/state/provision2BaseRatesSetup/actions.js